import WorkflowBuilder from './WorkflowBuilder';

export default function WorkflowCanvas({ workflow, hasWorkflows, onCreateWorkflow, focusMode = false }) {
  if (!hasWorkflows) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <h2 className="text-2xl font-semibold text-gray-800 mb-2">No workflows found</h2>
          <p className="text-sm text-gray-500 mb-4">Create your first workflow to start building automations.</p>
          {onCreateWorkflow ? (
            <button
              className="px-4 py-2 rounded bg-green-600 hover:bg-green-700 text-white text-sm"
              onClick={onCreateWorkflow}
            >
              Create Workflow
            </button>
          ) : null}
        </div>
      </div>
    );
  }

  if (!workflow) {
    return <div className="h-full flex items-center justify-center text-gray-500">Loading workflow...</div>;
  }

  return (
    <div className="w-full h-full overflow-auto">
      <WorkflowBuilder workflow={workflow} focusMode={focusMode} />
    </div>
  );
}
